util = require("../util/util.coffee")

# base muse model to set xhrconfig vars - all model should extend from MuseModel
class MuseModel extends coat.Model

    baseURL: ""

    constructor: (opts) ->
        super opts

        if muse?.webHost
            @baseURL = muse.webHost
            # if we have a baseURL (we are in a subdomain) we aren't allowed to 
            # modify the request header if we want to do a cross domain request
            @xhrConfig = (xhr) ->
                # if the cross domain requires authorization, pass credentials.
                xhr.withCredentials = true
                xhr

    xhrConfig: (xhr) ->
        if not xhr.headers then xhr.headers = {}
        xhr.setRequestHeader("X-Xsrftoken", util.getCookie("_xsrf"))
        # in order to avoid caching issues in ie10
        xhr.setRequestHeader("If-Modified-Since", "Sat, 01 Jan 2000 00:00:00 GMT")

module.exports = MuseModel



// WEBPACK FOOTER //
// ./node_modules/musecoreui/models/base.coffee